module.exports = __webpack_public_path__ + "img/sz.204cddf8.svg";